import React from 'react';
import AccordionReferralCard from 'components/card/AccordionReferralCard';
import { AssetReporter, EntityType, Referral } from 'types';
import { UserCard } from 'components/card/UserCard';


interface ReporterCardProps {
  referralData?:Referral | null
  referralId?: string;
  handleButtonClick: (type:EntityType) => void;
  handleEdit: (type:EntityType, reporter: AssetReporter) => void;
  handleDelete: (id: string, type:EntityType) => void;
  handleUserView: (user: any, title: string, description: string, children?: React.ReactNode) => void;
}

export default function ReporterCard({
  referralData,
  referralId,
  handleButtonClick,
  handleEdit,
  handleDelete,
  handleUserView
}: ReporterCardProps) {
  return (
    <AccordionReferralCard
      title={`Reporters - ${referralData?.reporters?.length || 0}`}
      buttonText="Add Reporter"
      onButtonClick={() => handleButtonClick("reporter")}
      disabled={
        !referralData ||
          [
          "Asset Recovery Requested",
          "Asset Recovery Request Approved",
          "Asset Recovery On Revision",
          "Asset Recovery Updated",
          "Asset Recovery On Litigation",
          "Asset Recovery Final Verdict",
          "Prohibition On litigation",
          "Prohibition Final Verdict",
        ].includes(referralData?.action_status as string)
      }
    >
      {referralData?.reporters && referralData.reporters.length > 0 ? (
        <div className="space-y-4 p-4">
          {referralData.reporters.map((reporter) => (
            <UserCard
              key={reporter.id}
              avatarUrl=""
              date={""}
              name={reporter?.person?.full_name as string}
              role={reporter?.person?.region as string}
              time={""}
              onDelete={() => handleDelete(reporter?.id as string, "reporter")}
              onEdit={() => handleEdit("reporter", reporter)}
              user={reporter.person}
              title="Reporter Details"
              description="Detailed information about reporter"
              disabled={
                      ![
                        "Investigation Ongoing",
                        "Pending",
                        "Prohibition On Revision",
                      ].includes(referralData?.action_status as string)
                    
              }
              onView={() => handleUserView(
                reporter.person,
                "Reporter Details",
                "Detailed information about reporter",
                <div className="space-y-3">
                  {reporter.relationship_to_case && (
                    <div>
                      <h4 className="font-semibold text-gray-700">
                        Relationship to Case
                      </h4>
                      <p className="text-gray-600">
                        {reporter.relationship_to_case}
                      </p>
                    </div>
                  )}
                </div>
              )}
            />
          ))}
        </div>
      ) : (
        <div className="p-4 text-center text-gray-500">
          No reporters added yet
        </div>
      )}
    </AccordionReferralCard>
  );
}